module.exports = __webpack_public_path__ + "img/freehand-en.43d04e7.jpg";